import { render, staticRenderFns } from "./CourseArrangement.vue?vue&type=template&id=58baca0a&scoped=true&"
import script from "./CourseArrangement.vue?vue&type=script&lang=js&"
export * from "./CourseArrangement.vue?vue&type=script&lang=js&"
import style0 from "./CourseArrangement.vue?vue&type=style&index=0&id=58baca0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58baca0a",
  null
  
)

export default component.exports